exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.errorMessages[data-v-53dc4f45] {\n  margin-bottom: 1em;\n}\n", ""]);

// exports
